import type { ReactNode } from 'react';

type ModalProps = {
  isOpen: boolean;
  title: string;
  children: ReactNode;
  onClose: () => void;
  footer?: ReactNode;
};

const Modal = ({ isOpen, title, children, footer }: ModalProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/25">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full relative">
        {/* Modal Title */}
        <h2 className="text-header-sm font-semibold">{title}</h2>

        {/* Content */}
        <div className="mt-4">{children}</div>

        {/* Footer */}
        {footer && <div className="mt-6 flex justify-end space-x-2">{footer}</div>}
      </div>
    </div>
  );
};

export { Modal };
